import { Routes } from '@angular/router';
import { authGuard, loginGuard } from '@okcargo-apps/guards-ionic';
import { CRUD_USERS_CAPABILITIES, ECapabilities } from '@okcargo-apps/shared-domain-ionic';
import { DECA_ROUTES } from './deca/deca.routes.config';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./layout/pages/tabs/tabs.routes').then((m) => m.routes),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  // digital control new routes

  {
    path: 'deca-past',
    loadComponent: () => import('./layout/pages/deca-past/deca-past.page').then((m) => m.DecaPastPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.VIEW_DECA_AS_SHIPPER },
  },
  {
    path: 'deca-upcoming',
    loadComponent: () => import('./layout/pages/deca-upcoming/deca-upcoming.page').then((m) => m.DecaUpcomingPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.VIEW_DECA_AS_SHIPPER },
  },

  {
    path: 'deca-carrier-past',
    loadComponent: () =>
      import('./layout/pages/deca-carrier-past/deca-carrier-past.page').then((m) => m.DecaCarrierPastPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.VIEW_DECA_AS_CARRIER },
  },
  {
    path: 'deca-carrier-upcoming',
    loadComponent: () =>
      import('./layout/pages/deca-carrier-upcoming/deca-carrier-upcoming.page').then((m) => m.DecaCarrierUpcomingPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.VIEW_DECA_AS_CARRIER },
  },

  {
    path: 'deca-detail/:id',
    loadComponent: () => import('./layout/pages/deca-detail/deca-detail.page').then((m) => m.DecaDetailPage),
    canActivate: [authGuard],
    data: { requiredCapabilities: [ECapabilities.VIEW_DECA_AS_CARRIER, ECapabilities.VIEW_DECA_AS_SHIPPER] },
  },

  {
    path: 'deca-new',
    loadComponent: () => import('./layout/pages/deca-new/deca-new.page').then((m) => m.DecaNewPage),
    canActivate: [authGuard],
    data: { requiredCapabilities: [ECapabilities.CREATE_DECA_AS_CARRIER, ECapabilities.CREATE_DECA_AS_SHIPPER] },
  },
  {
    path: 'deca-new/:id',
    loadComponent: () => import('./layout/pages/deca-new/deca-new.page').then((m) => m.DecaNewPage),
    canActivate: [authGuard],
    data: { requiredCapabilities: [ECapabilities.CREATE_DECA_AS_CARRIER, ECapabilities.CREATE_DECA_AS_SHIPPER] },
  },
  {
    path: 'deca-transfer/:id',
    loadComponent: () => import('./layout/pages/deca-new/deca-new.page').then((m) => m.DecaNewPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.CREATE_DECA_AS_SHIPPER, docMode: 'transfer' },
  },

  {
    path: 'deca-edit/:id',
    loadComponent: () => import('./layout/pages/deca-edit/deca-edit.page').then((m) => m.DecaEditPage),
    canActivate: [authGuard],
    data: { requiredCapabilities: [ECapabilities.CREATE_DECA_AS_CARRIER, ECapabilities.CREATE_DECA_AS_SHIPPER] },
  },

  {
    path: 'batch-imports',
    loadComponent: () => import('./layout/pages/batch-import/batch-import.page').then((m) => m.BatchImportPage),
    canActivate: [authGuard],
    data: { requiredCapabilities: [ECapabilities.CREATE_DECA_AS_CARRIER, ECapabilities.CREATE_DECA_AS_SHIPPER] },
  },
  {
    path: 'batch-import-errors/:id',
    loadComponent: () =>
      import('./layout/pages/batch-import-errors/batch-import-errors.page').then((m) => m.BatchImportErrorsPage),
    canActivate: [authGuard],
    data: { requiredCapabilities: [ECapabilities.CREATE_DECA_AS_CARRIER, ECapabilities.CREATE_DECA_AS_SHIPPER] },
  },

  // backward-compatible redirects from the old digital-control urls
  { path: 'digital-control-past', redirectTo: DECA_ROUTES.SHIPPER_PAST, pathMatch: 'full' },
  { path: 'digital-control-upcoming', redirectTo: DECA_ROUTES.SHIPPER_UPCOMING, pathMatch: 'full' },
  { path: 'digital-control-carrier-past', redirectTo: DECA_ROUTES.CARRIER_PAST, pathMatch: 'full' },
  { path: 'digital-control-carrier-upcoming', redirectTo: DECA_ROUTES.CARRIER_UPCOMING, pathMatch: 'full' },
  { path: 'digital-control-detail/:id', redirectTo: `${DECA_ROUTES.DETAIL}/:id` },
  { path: 'digital-control-shipper-new', redirectTo: DECA_ROUTES.NEW, pathMatch: 'full' },
  { path: 'digital-control-carrier-new', redirectTo: DECA_ROUTES.NEW, pathMatch: 'full' },
  { path: 'digital-control-edit/:id', redirectTo: `${DECA_ROUTES.EDIT}/:id` },

  // backward-compatible redirects from the role-specific creation urls
  { path: 'deca-shipper-new', redirectTo: DECA_ROUTES.NEW, pathMatch: 'full' },
  { path: 'deca-carrier-new', redirectTo: DECA_ROUTES.NEW, pathMatch: 'full' },
  { path: 'deca-shipper-new/:id', redirectTo: `${DECA_ROUTES.NEW}/:id` },
  { path: 'deca-carrier-new/:id', redirectTo: `${DECA_ROUTES.NEW}/:id` },

  {
    path: 'contact-book',
    loadComponent: () => import('./layout/pages/contact-book/contact-book.page').then((m) => m.ContactBookPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'users',
    loadComponent: () => import('./layout/pages/users/users.page').then((m) => m.UsersPage),
    canActivate: [authGuard],
    data: { requiredCapabilities: [...CRUD_USERS_CAPABILITIES] },
  },

  // old routes, to be removed when the new ones are ready
  {
    path: 'account',
    loadComponent: () => import('./layout/pages/account/account.page').then((m) => m.AccountPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'account/password',
    loadComponent: () => import('./layout/pages/password/password.page').then((m) => m.PasswordPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'my-company',
    loadComponent: () => import('./layout/pages/my-company/my-company.page').then((m) => m.MyCompanyPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'help',
    loadComponent: () => import('./layout/pages/help/help.page').then((m) => m.HelpPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'support',
    loadComponent: () => import('./layout/pages/support/support.page').then((m) => m.SupportPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'login',
    loadComponent: () => import('./layout/pages/login/login.page').then((m) => m.LoginPage),
    canActivate: [loginGuard],
  },
  {
    path: 'recover-password',
    loadComponent: () =>
      import('./layout/pages/recover-password/recover-password.page').then((m) => m.RecoverPasswordPage),
    canActivate: [loginGuard],
  },
  {
    path: 'recover-password-confirm',
    loadComponent: () =>
      import('./layout/pages/recover-password-confirm/recover-password-confirm.page').then(
        (m) => m.RecoverPasswordConfirmPage,
      ),
    canActivate: [loginGuard],
  },
  {
    path: 'registration',
    loadComponent: () => import('./layout/pages/registration/registration.page').then((m) => m.RegistrationPage),
    canActivate: [loginGuard],
  },
  {
    path: 'error',
    loadComponent: () => import('./layout/pages/error/error.page').then((m) => m.ErrorPage),
  },
  {
    path: 'update-required',
    loadComponent: () =>
      import('./layout/pages/update-required/update-required.page').then((m) => m.UpdateRequiredPage),
  },
  // catch all
  { path: '**', redirectTo: '/', pathMatch: 'full' },
];
